




























































































































import Search from '@/views/organisms/Search.vue'
import ApiClient from '@/common/api'
import store from '@/store'
import Global from '@/common/global.js'
import BlueButton from '@/views/atoms/BlueButton.vue'
import SelectBox from '@/views/atoms/SelectBox.vue'
import CheckBox from '@/views/atoms/CheckBox.vue'
import PopupCommentAdd from '@/views/template/PopupCommentAdd.vue'
import PopupDisplayItem from '@/views/template/PopupDisplayItem.vue'
import PopupFileUpload from '@/views/template/PopupFileUpload.vue'
import StatusBox from '@/views/molecules/StatusBox.vue'
import PopupVehicleInformationComment from '@/views/template/PopupVehicleInformationComment.vue'
import TextBox from '@/views/atoms/TextBox.vue'
import TextDatePicker from '@/views/molecules/NoStoreTextDatePicker.vue'
import PopupComfirmDelete from '@/views/template/PopupComfirmDelete.vue'
import PopupCutDate from '@/views/template/PopupCutDate.vue'

export default
  name: 'Fc'

  components: {
    Search
    ApiClient
    BlueButton
    SelectBox
    CheckBox
    PopupCommentAdd
    PopupDisplayItem
    PopupFileUpload
    StatusBox
    PopupVehicleInformationComment
    TextBox
    TextDatePicker
    PopupComfirmDelete
    PopupCutDate
  }

  data: () ->
    exportList: {},
    statusList: Global.status(),
    showCommentAdd: false,
    showDisplayItem: false,
    showHsi: false,
    showMsi: false,
    showAcl: false,
    showExportPermit: false,
    showCarryInSlip: false,
    showPicture: false,
    showVehicleInformation: false,
    showVehicleInformationComment: false,
    showFreightDetail: false,
    showDraftBl: false,
    showCustomMaterial: false,
    showInvoice: false,
    id: '',
    workingStyleList: Global.workingStyle(),
    shippingFormList: Global.shippingForm(),
    customsClearanceList: Global.customsClearance(),
    shipComment: '',
    displayItems: store.getters.defaultSetCustomsBrokerDisplayItems,
    shipCommentId: '',
    voy: '',
    ship_name: '',
    loading_area: '',
    landing_area: '',
    searchParam: {}
    aclSave: true
    mblSave: true
    hblSave: true
    fcLabel: Global.fcLabel()
    sortChange: {}
    showSorts: {}
    level: 0
    booking: ''
    shipper_name: ''
    beforeStr: ''
    statusData: {}
    date: null
    showCutDate: false
    complete_flg: ''
    timeStyle: ''
    changeLedgerNumberObj: {}
    pickupDateObj: {}
    pickupTimeObj: {}

  created: () ->
    store.dispatch('initPostParam')
    @sort('departure_date_plan')
    api = new ApiClient()
    data = await api.get('/customs_broker/login/user_level')
    @level = Number(data.level)
    if store.getters.defaultSetCustomsBrokerDisplayItems
      store.dispatch('setCustomsBrokerDisplayItems', store.getters.defaultSetCustomsBrokerDisplayItems)

  methods: {
    getFcList:() ->
      post = false
      api = new ApiClient()
      data = await api.post('/customs_broker/search/list', @searchParam)
      @exportList = data.list

    checkBox: (num) ->
      if num == "0"
        return false
      return true

    clickComment: (id, comment, ship_comment_id, voy, ship_name, loading_area, landing_area, booking, shipper_name, status, key) ->
      @id = id
      @shipComment = comment
      @shipCommentId = ship_comment_id
      @voy = voy
      @ship_name = ship_name
      @loading_area = loading_area
      @landing_area = landing_area
      @booking = booking
      @shipper_name = shipper_name
      @showCommentAdd = true
      @statusData = {
        id: id,
        index: key,
        status: status,
      }

    close_comment_add: (e) ->
      @showCommentAdd = false

    clickDisplayItem: () ->
      @showDisplayItem = true

    clickCustomMaterial: (id, row) ->
      @id = id
      @booking = row.booking
      @shipper_name = row.shipper_name
      @complete_flg = row.custom_materials_complete_flg
      @showCustomMaterial = true

    clickHsi: (id, row) ->
      @id = id
      @booking = row.booking
      @shipper_name = row.shipper_name
      @showHsi = true

    clickMsi: (id, row) ->
      @id = id
      @booking = row.booking
      @shipper_name = row.shipper_name
      @showMsi = true

    clickAcl: (id, row) ->
      @id = id
      @booking = row.booking
      @shipper_name = row.shipper_name
      if @grayOutCustomsClearance(row)
        @aclSave = false
      else
        @aclSave = true
      @showAcl = true

    clickExportPermit: (id, row) ->
      @id = id
      @booking = row.booking
      @shipper_name = row.shipper_name
      @showExportPermit = true

    clickCarryInSlip: (id, row) ->
      @id = id
      @booking= row.booking
      @shipper_name = row.shipper_name
      @showCarryInSlip = true

    clickPicture: (id, row) ->
      @id = id
      @booking = row.booking
      @shipper_name = row.shipper_name
      @showPicture = true

    clickVehicleInformation: (id, row) ->
      @id = id
      @booking = row.booking
      @shipper_name = row.shipper_name
      @showVehicleInformation = true

    clickVehicleInformationComment: (id, row) ->
      @id = id
      @booking = row.booking
      @shipper_name = row.shipper_name
      @showVehicleInformationComment = true

    clickFreightDetail: (id, row) ->
      @id = id
      @booking = row.booking
      @shipper_name = row.shipper_name
      @showFreightDetail = true

    clickDraftBl: (id, row) ->
      @id = id
      @booking = row.booking
      @shipper_name = row.shipper_name
      @showDraftBl = true

    clickInvoice: (id, row) ->
      @id = id
      @booking = row.booking
      @shipper_name = row.shipper_name
      @showInvoice = true

    closeDisplayItem: (e) ->
      @showDisplayItem = false

    closeCustomMaterial: (e) ->
      @showCustomMaterial = false

    closeHsi: (e) ->
      @showHsi = false

    closeMsi: (e) ->
      @showMsi = false

    closeAcl: (e) ->
      @showAcl = false

    closeExportPermit: (e) ->
      @showExportPermit = false

    closeCarryInSlip: (e) ->
      @showCarryInSlip = false

    closePicture: (e) ->
      @showPicture = false

    closeVehicleInformation: (e) ->
      @showVehicleInformation = false

    closeVehicleInformationComment: (e) ->
      @showVehicleInformationComment = false

    closeFreightDetail: (e) ->
      @showFreightDetail = false

    closeDraftBl: (e) ->
      @showDraftBl = false

    closeInvoice: (e) ->
      @showInvoice = false

    rv_color: (flag) ->
      if flag == '0'
        return false
      return true

    shippingForm: (num) ->
      return @shippingFormList[num].name

    customsClearance: (num) ->
      return @customsClearanceList[num].name

    commentSave: () ->
      @close_comment_add()
      @getFcList()

    click_search: (postParam) ->
      @searchParam = Object.assign(@searchParam, postParam)
      @getFcList()

    workingStyletext: (row) ->
      text = ''
      if !row.working_style
        return '未選択'
      for row, index in row.working_style
        i = row.working_style_id - 1
        if index > 0
          text += '・'
        text += @workingStyleList[i].name
      return text
    grayOutBusiness: (row) ->
      if !row.working_style
        return false
      flag = false
      for r, index in row.working_style
        if r.working_style_id == '1'
          return false
        if r.working_style_id == '2'
          flag = true
        if r.working_style_id == '5'
          return false
      if flag
        return true
      return false
    grayOutCustomsClearance: (row) ->
      if !row.working_style
        return false
      flag = false
      for r, index in row.working_style
        if r.working_style_id == '1'
          return false
        if r.working_style_id == '2'
          return false
        if r.working_style_id == '3'
          flag = true
        if r.working_style_id == '4'
          return false
        if r.working_style_id == '5'
          return false
      if flag
        return true
      return false
    grayOutWarehouse: (row) ->
      if !row.working_style
        return false
      flag = false
      for r, index in row.working_style
        if r.working_style_id == '1'
          return false
        if r.working_style_id == '2'
          return false
        if r.working_style_id == '4'
          flag = true
        if r.working_style_id == '5'
          return false
      if flag
        return true
      return false
    changeLedgerNumber: (v) ->
      # storeに値を持たさないように設定していたので、変更した値を逃がしてボタンを押したときに変更させるようにする。(無理やりです。)
      @changeLedgerNumberObj[@exportList[v.index].id] = v.val

    grayOutCfs:(row) ->
      if !row.shipping_form
        return false
      if row.shipping_form == '3'
        return true
      return false
    grayOutLcfs:(row) ->
      if !row.shipping_form
        return false
      if row.shipping_form == '4'
        return true
      return false
    grayOutAir:(row) ->
      if !row.shipping_form
        return false
      if row.shipping_form == '5'
        return true
      return false
    grayOutBulk:(row) ->
      if !row.shipping_form
        return false
      if row.shipping_form == '6'
        return true
      return false
    grayOutUnworked:(row) ->
      if !row.shipping_form
        return false
      if row.shipping_form == '7'
        return true
      return false
    sort: (str) ->
      if @sortChange[str]
        @$set(@sortChange, str, false)
        param = @searchParam
        delete param[@beforeStr + '_asc']
        delete param[@beforeStr + '_desc']
        param[str + '_desc'] = 'desc'
      else
        @$set(@sortChange, str, true)
        param = @searchParam
        delete param[@beforeStr + '_asc']
        delete param[@beforeStr + '_desc']
        param[str + '_asc'] = 'asc'
      @showSort(str);
      @beforeStr = str
      api = new ApiClient()
      data = await api.post('/customs_broker/search/list', param)
      @exportList = data.list
      @searchParam = param
    showSort: (str) ->
      @$set(@showSorts, str, true)
      for row, key in Object.keys(@sortChange)
        if str != row
          @$set(@showSorts, row, false)
    click_clear: (postParam) ->
      @searchParam = Object.assign(@searchParam, postParam)
      @getFcList()
    popupCutDateNumber: (id, date, time_style) ->
      @id = id
      @date = date
      @timeStyle = time_style
      @showCutDate = true
    closeCutDate: () ->
      @showCutDate = false
    saveCutDate: (v) ->
      api = new ApiClient()
      data = await api.post('/fc/save', v)
      @getFcList()
      @closeCutDate()
  }
